import { css } from '@emotion/react';

const DataTags = () => {
  //
  return (
    <div>
      <h2 css={css`margin: 1em`}>Data Tags</h2>
      <div css={css`padding: 1em`}>
        <p css={(theme) => css`color: ${theme.flora}; font-weight: bold`}>Coming Soon ...</p>
      </div>
    </div>
  )
};

export default DataTags;

